import styled, { css } from "styled-components";
import { DEFAULT_FLEX_PROPS } from "./Flex.constants.js";
import { DefaultFlexProps, FlexProps } from "./Flex.types.js";

const justifyMap: Record<NonNullable<FlexProps["justify"]>, CSSStyleDeclaration["justifyContent"]> = {
    start: "flex-start",
    end: "flex-end",
    center: "center",
    between: "space-between",
    around: "space-around",
    evenly: "space-evenly",
};

const alignMap: Record<NonNullable<FlexProps["align"]>, CSSStyleDeclaration["alignItems"]> = {
    start: "flex-start",
    end: "flex-end",
    center: "center",
    stretch: "stretch",
    baseline: "baseline",
};

export const flex = css<FlexProps>`
    display: flex;
    flex-direction: ${(props) => props.direction ?? DEFAULT_FLEX_PROPS.direction};
    justify-content: ${(props) => justifyMap[props.justify ?? DEFAULT_FLEX_PROPS.justify]};
    align-items: ${(props) => alignMap[props.align ?? DEFAULT_FLEX_PROPS.align]};
    flex-wrap: ${(props) => props.wrap ?? DEFAULT_FLEX_PROPS.wrap};
    gap: ${(props) => props.theme.spacing[props.gap ?? DEFAULT_FLEX_PROPS.gap]};
    ${(props) => props.width && `width: ${props.width};`}
`;

export const FlexStyle = styled.div<FlexProps & DefaultFlexProps>`
    ${flex}
`;
